export default __webpack_public_path__ + "media/images/cta_blocks/guest_view_website-d1b6b591dd9429d9b90ced5bbc4aa8c4.jpg";